import React from 'react';
import { Button, Modal, Form, Header, Label } from 'semantic-ui-react';

import { useDispatch } from 'react-redux';
import { setToast } from '../../store/ToastManagement';

import { useForm } from '../../_helpers/hooks/form';
import { useCurrentUser } from '../../_services';

export const PasswordResetModal = ({ userId = 0 }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { currentUser, resetPassword } = useCurrentUser();
  const requestCurrentPassword = userId === 0;

  const dispatch = useDispatch();
  const displaySuccess = () =>
    dispatch(
      setToast({
        title: 'Success!',
        body: 'Password was successfully reset.'
      })
    );

  const handleSubmit = React.useCallback(
    async values => {
      await resetPassword(
        userId ? userId : currentUser.id,
        values.currentPassword,
        values.password
      );
    },
    [currentUser, resetPassword]
  );

  const {
    values,
    onFieldChange,
    onFieldBlur,
    onSubmit,
    error,
    fieldHasError,
    didSucceed,
    errors,
    resetForm
  } = useForm({
    initialValues: {
      password: '',
      confirm: '',
      currentPassword: requestCurrentPassword ? '' : 'XXXXXXXX'
    },
    onSubmit: handleSubmit,
    validators: {
      password: [
        ({ password }) =>
          password.length < 10 && 'Must be at least 10 characters'
      ],
      confirm: [
        ({ password, confirm: confirmPw }) =>
          password !== confirmPw && 'Passwords must match'
      ]
    }
  });

  React.useEffect(() => {
    if (didSucceed) {
      resetForm();
      setIsModalOpen(false);
      displaySuccess();
    }
  }, [didSucceed, displaySuccess, resetForm]);

  const createOnChangeHandler = field => (_, { value }) =>
    onFieldChange(field, value);

  const open = event => {
    event.preventDefault();
    event.stopPropagation();
    setIsModalOpen(true);
  };
  const cancel = event => {
    event.preventDefault();
    event.stopPropagation();
    setIsModalOpen(false);
    resetForm();
  };

  return (
    <React.Fragment>
      <Button color="olive" onClick={open}>
        Change Password
      </Button>
      <Modal open={isModalOpen} size="mini" style={{ padding: '20px' }}>
        <Modal.Content>
          <Header as="h2" textAlign="left">
            Change Password
          </Header>
          <Form onSubmit={onSubmit}>
            {error && (
              <Label basic color={'red'} className={'red'}>
                {error}
              </Label>
            )}
            <Form.Field>
              {requestCurrentPassword && (
                <Form.Input
                  label="Current Password"
                  type="password"
                  icon="lock"
                  iconPosition="left"
                  placeholder="Current password"
                  onChange={createOnChangeHandler('currentPassword')}
                  value={values.currentPassword}
                  onBlur={() => onFieldBlur('currentPassword')}
                  error={
                    fieldHasError('currentPassword') && errors.currentPassword
                  }
                />
              )}
            </Form.Field>

            <Form.Field>
              <Form.Input
                label="New Password"
                type="password"
                icon="lock"
                iconPosition="left"
                placeholder="Must be at least 10 characters"
                onChange={createOnChangeHandler('password')}
                value={values.password}
                onBlur={() => onFieldBlur('password')}
                error={fieldHasError('password') && errors.password}
              />
            </Form.Field>

            <Form.Field error={fieldHasError('confirm')}>
              <Form.Input
                label="Confirm New Password"
                type="password"
                icon="lock"
                iconPosition="left"
                placeholder="Enter the same password"
                onChange={createOnChangeHandler('confirm')}
                value={values.confirm}
                onBlur={() => onFieldBlur('confirm')}
                error={fieldHasError('confirm') && errors.confirm}
              />
            </Form.Field>

            <Button type="submit" color="olive">
              Change Password
            </Button>
            <Button onClick={cancel}>Cancel</Button>
          </Form>
        </Modal.Content>
      </Modal>
    </React.Fragment>
  );
};
